<template>
  <nx-dialog
    className="vbuy-dialog"
    v-model="show"
    :content="titleText"
    :btns="dialogButtons"
    :showConfirmButton="false"
  ></nx-dialog>
</template>

<script>
import { getQueryString, goBack } from 'utils/common'
import env from '@/utils/clientEnv'
export default {
  name: 'vip-first-buy-popup',
  data() {
    return {
      vipBuyStatus: 0,
      skuInfo: {},
      isTrackClick: false, // 单纯下架不上报（活动结束、库存不足、等级不符合要求满足其一就上报）
      callback: null,
      show: true,
      env
    }
  },
  computed: {
    titleText() {
      // vipBuyStatus:   0 成功， 1 活动结束， 2 活动库存不足 3 购买数量超出限制 4 常规库存不足， 5 活动条件不满足
      return [
        '',
        '暂无进行中会员先享购活动，可预定购买~',
        '当前会员先享购商品已售罄，可预定购买~',
        '购买数量超限',
        '当前会员先享购商品已售罄，可预定购买~',
        '您当前的会员等级不满足要求，了解更多商品详情'
      ][this.vipBuyStatus]
    },
    dialogButtons() {
      let btns = []
      if (this.vipBuyStatus == 5) {
        if (!env.isPadVivoApp) {
          btns.push({
            text: '升级会员',
            handler: () => {
              this.upLevelVip('升级会员')
            }
          })
        }
        btns.push({
          text: '了解商品详情',
          handler: () => {
            this.viewCommonProduct('了解商品详情')
          },
          type: 'link'
        })
      } else {
        btns = [
          {
            text: '去预定商品',
            handler: () => {
              this.viewCommonProduct('去预定商品')
            }
          },
          {
            text: '我知道了',
            handler: () => {
              this.closeVipPopup()
            },
            type: 'link'
          }
        ]
      }
      return btns
    }
  },
  mounted() {
    // 组件曝光埋点
    this.$track({
      cfrom: '199|002|02|077',
      event_id: '199|002|02|077',
      page_name: 1,
      page_type: 8,
      content: this.titleText,
      reportType: 2
    })
  },
  methods: {
    viewCommonProduct(text) {
      this.isTrackClick && this.clickTrack(text)
      let skuId = this.skuInfo?.commoditySkuBaseInfo.skuId
      var productUrl = localStorage.getItem('productUrl')
      let url = productUrl ? decodeURIComponent(productUrl) : window.location.href
      url = url.split('?')[0]
      window.location.href = skuId ? `${url}?skuId=${skuId}` : url
    },
    upLevelVip(text) {
      this.clickTrack(text)
      let url = this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityVipFirst?.upLevelUrl
      url && (window.location.href = url)
    },
    clickTrack(text) {
      this.$track({
        cfrom: '199|001|01|077',
        event_id: '199|001|01|077',
        page_name: 1,
        page_type: 8,
        button_name: text,
        content: this.titleText,
        reportType: 2,
        taskType: 2
      })
    },
    // 返回上一页
    goBack() {
      goBack()
    },
    closeVipPopup() {
      this.show = false
      if (this.callback) {
        this.callback()
      }
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
